<form *ngIf="addEditForm && validation" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxGiftStatus)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty" >
    <div class="ui-grid-row">
      <!-- Stato Iniziale -->
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.status_initial_id.nullable}">{{ validation.status_initial_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [options]="statusDefinition" [filter]="true" formControlName="status_initial_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.status_initial_id"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <!-- Stato Finale -->
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.status_final_id.nullable}">{{ validation.status_final_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [options]="statusDefinition" [filter]="true" formControlName="status_final_id" placeholder="{{'common.select_something' | translate}}"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.status_final_id"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <!-- Azione -->
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.action.nullable}">{{ validation.action.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input id="action" name="action" formControlName="action" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="validation.action"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <br />
      <!-- Bottone di Aggiunta/Modifica-->
      <button id="addGiftStatus" name="addGiftStatus" class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{dialogBoxGiftStatus.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'loyalty.reservationGiftStatus' |translate }}"></button>
    </div>
  </p-footer>
</form>




// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-gift-status/loyalty-reservation-gift-status-form/loyalty-reservation-gift-status-form.component.html